<script setup lang="ts">
import Spinner from '~/components/ui/Spinner.vue'

const props = defineProps<{
  pending: boolean
}>()
</script>

<template>
  <div class="relative">
    <!-- Parent content -->
    <slot />

    <!-- Overlay -->
    <div
      v-if="props.pending"
      class="absolute inset-0 bg-white/40 backdrop-blur-sm flex items-start pt-40 justify-center z-5 rounded-2xl min-h-100"
      aria-live="polite"
      aria-busy="true"
    >
      <Spinner />
    </div>
  </div>
</template>
